export default ({ theme }) => ({
  overflow: 'auto',
  padding: '0 30px',
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.down(theme.desktopBreakPoint)]: {
    padding: '0 16px 100px'
  },
  '& .content': {
    // paddingTop: 20,
  },
  '& .actionsContainer': {
    marginBottom: 18,
    backgroundColor: '#FFF',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      marginBottom: 0,
      padding: '8px 12px',
      boxShadow: '0px -5px 5px #00000026'
    }
  },
  '& .actionsBtnsWrapper': {
    display: 'flex',
    // alignItems: 'center',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      justifyContent: 'center'
    }
  },
  '& .goBackBtn': {
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      position: 'absolute',
      top: 5,
      left: 5,
      zIndex: 1,
      backgroundColor: '#FFF'
    }
  },
  '& .row': {
    marginBottom: 16,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    '& .label': {
      marginBottom: 0
    },
    '& .text': {
      marginBottom: 0,
      textAlign: 'right'
    }
  },
  '& .rowColumnRight': {
    flex: 1,
    marginLeft: 15,
    textAlign: 'right'
  },
  '& .text': {
    marginBottom: 20,
    fontSize: 14,
    lineHeight: '22px',
    color: '#5E6060',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 16
    }
  },
  '& .label': {
    marginBottom: 12,
    fontSize: 11,
    lineHeight: '13px',
    color: '#A4A3A4',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 10,
      lineHeight: '22px',
      fontSize: 14
    }
  },
  '& .job__title': {
    marginBottom: 33,
    fontSize: 20,
    fontWeight: 'bold',
    lineHeight: '24px',
    color: '#6A6A6A',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginBottom: 20,
      fontSize: 18,
      lineHeight: '22px'
    }
  },
  '& .job__employer': {
    marginBottom: 12,
    fontSize: 14,
    fontWeight: 'bold',
    lineHeight: '22px',
    color: '#5E6060',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {}
  },
  '& .job__photo': {
    marginBottom: 18,
    objectFit: 'cover',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      borderRadius: 25
    }
  },
  '& .applyBtn': {
    minWidth: 118,
    height: 45,
    padding: '0 12px',
    borderRadius: 8,
    fontSize: 14,
    '&.applied': {
      backgroundColor: theme.palette.success.main
    },
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      minWidth: 100,
      height: 36,
      padding: '0 6px'
    }
  },
  '& .cancelBtn': {
    minWidth: 118,
    height: 45,
    marginLeft: 18,
    padding: '0 12px',
    borderRadius: 8,
    fontSize: 14,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      minWidth: 100,
      height: 36,
      padding: '0 6px',
      marginLeft: 12
    }
  },
  '& .secondaryActionWrapper': {
    marginLeft: 18,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      marginLeft: 12
    }
  },
  '& .secondaryActionWrapper_labeled': {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  '& .secondaryAction__label': {
    display: 'none',
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      display: 'block',
      textAlign: 'center',
      fontSize: 12,
      fontWeight: 'bold',
      color: theme.palette.primary.main
    }
  },
  '& .secondaryAction': {
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      width: 36,
      height: 36,
      marginBottom: 4,
      fontSize: 20
    }
  },
  '& .loaderOverlay': {
    width: '100%',
    height: '100%',
    position: 'absolute',
    left: 0,
    top: 0,
    zIndex: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.7)'
  },
  '& .interviewDate': {
    marginBottom: 6,
    fontSize: 12,
    textAlign: 'left',
    color: theme.palette.primary.main,
    [theme.breakpoints.down(theme.desktopBreakPoint)]: {
      textAlign: 'center'
    }
  },
  '& .shareButton': {
    height: 45,
    minWidth: 118,
    padding: '0 15px',
    fontSize: 14,
    borderRadius: 8
  }
});
